<div class="details-container-wrapper">
    <div class="details-container">
        <div class="head-button">
            <button class="r-btn" (click)="backToMainTable()"><i class="icon bi bi-arrow-left"></i></button>
            <span class="head-text">Back</span>
        </div>

        <div class="og-details">
            @if (pureOriginalService.errorMessage()) {
            <span>{{pureOriginalService.errorMessage()}}</span>
            } @else {
            <div class="details-left">
                <div class="claim-above-tabs">
                    <app-claim-file
                        [pureOriginalId]="pureOriginalId()"
                        [pureOriginalUser]="pureOriginalUser()"
                        (checkIfButtonIsDisabled)="getDisabledButton($event)">
                    </app-claim-file>
                    <div class="status-pill" [ngClass]="{
                                'done-bg': pureOriginalService.pureOriginalDetails().status === 'DONE',
                                'waiting-bg': pureOriginalService.pureOriginalDetails().status === 'WAITING',
                                'in-progress-bg': pureOriginalService.pureOriginalDetails().status === 'IN_PROGRESS',
                                'error-text-bg': pureOriginalService.pureOriginalDetails().status === 'ERROR'
                           }">
                        <span class="status-text">{{pureOriginalService.pureOriginalDetails().status}}</span>
                    </div>
                </div>
                <app-pure-original-matching-details [pureOriginalId]="pureOriginalId()"
                    [pureOriginalMatchingIds]="pureOriginalMatchingIds()" (isFileModalOpened)="openFileModal($event)"
                    (versionName)="getVersionName($event)" [isClaimedFile]="disabled()"
                    [isImpossibleTuningUploaded]="isImpossibleTuningUploaded()"></app-pure-original-matching-details>
                <app-file-attachments-container
                    entityType="pureOriginal"
                    [entityId]="pureOriginalId()">
                </app-file-attachments-container>
            </div>
            <div class="details-right">
                <app-pure-originals-info [pureOriginalId]="pureOriginalId()" (isFileModalOpened)="openFileModal($event)"
                    (pureOriginalUser)="getPureOriginalUser($event)"
                    [buttonIsDisabled]="disabled()"></app-pure-originals-info>
            </div>
            }

        </div>

        @if (isFileModalOpened()) {
        <app-file-upload-modal [pureOriginalBaseId]="pureOriginalId().toString()" [versionName]="versionName()"
            [isFileModalOpened]="isFileModalOpened()" (isFileModalClosed)="closeModal($event)"></app-file-upload-modal>
        }

    </div>

</div>